import type { ContentCardProps } from "sj-ui-toolkit/src/atlas/components/ContentCard";
import { ContentCard } from "sj-ui-toolkit/src/atlas/components";

interface LessonsContainerProps {
  title: string;
  lessons?: (Omit<ContentCardProps, "id"> & { id: number | string })[];
  roleId?: string;
  roleEnrollmentId?: number;
  disabled?: boolean;
  // Accepted for parity with Path's call sites; lesson navigation happens inside
  // ContentCard, so the container itself never invokes this.
  onLessonClick?: (lessonRoute: string) => void;
}

export const LessonsContainer = ({
  title,
  lessons = [],
  roleId,
  roleEnrollmentId,
  disabled = false,
  onLessonClick: _onLessonClick,
}: LessonsContainerProps) => {
  const sectionId = `lessons-section-${title.toLowerCase().replace(/\s+/g, "-")}`;

  return (
    <section className="py-8" aria-labelledby={sectionId}>
      <h2 className="atlas-h5" id={sectionId}>
        {title}
      </h2>
      <ul className="flex flex-wrap gap-6 mt-4 list-none p-0 m-0" role="list">
        {lessons.map(lesson => (
          <li key={lesson.id}>
            <ContentCard
              {...lesson}
              id={String(lesson.id)}
              roleId={roleId}
              roleEnrollmentId={roleEnrollmentId}
              disabled={disabled}
              headingLevel="h3"
            />
          </li>
        ))}
      </ul>
    </section>
  );
};
